module.exports = __webpack_public_path__ + "static/hero2-3843dc68ee02052089f99b971dbac5d5.jpg";